import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const SYNC_INTERVAL = 12 * 60 * 60 * 1000; // 12 hours

const saveToCache = (type, data) => {
  try {
    const cacheEntry = { data, savedAt: new Date().toISOString() };
    localStorage.setItem(`ashop_export_${type}`, JSON.stringify(cacheEntry));
  } catch (e) {
    console.error(`Cache save failed for ${type}:`, e);
  }
};

const runBackup = async () => {
  if (!navigator.onLine) return false;

  try {
    // Fetch all active packages
    const allRes = await axios.get(`${API}/packages?active_only=false`);
    const allPackages = allRes.data;

    // Save different views
    saveToCache('all', allPackages);
    saveToCache('available', allPackages.filter(p => !p.is_picked_up));
    saveToCache('picked_up', allPackages.filter(p => p.is_picked_up));

    // Fetch history
    try {
      const histRes = await axios.get(`${API}/packages/history/all`);
      saveToCache('history', histRes.data);
    } catch (e) {
      // History might be empty, that's OK
      saveToCache('history', []);
    }

    // Save backup timestamp
    localStorage.setItem('ashop_last_backup', new Date().toISOString());
    console.log(`[AutoBackup] Backup complete: ${allPackages.length} packages cached`);
    return true;
  } catch (error) {
    console.error('[AutoBackup] Backup failed:', error);
    return false;
  }
};

const shouldRunBackup = () => {
  const lastBackup = localStorage.getItem('ashop_last_backup');
  if (!lastBackup) return true;
  const elapsed = Date.now() - new Date(lastBackup).getTime();
  return elapsed >= SYNC_INTERVAL;
};

let backupTimer = null;

const startAutoBackup = () => {
  // Run immediately if needed
  if (shouldRunBackup()) {
    runBackup();
  }

  // Schedule every 12 hours
  if (backupTimer) clearInterval(backupTimer);
  backupTimer = setInterval(() => {
    runBackup();
  }, SYNC_INTERVAL);

  console.log('[AutoBackup] Auto-backup scheduler started (every 12h)');
};

const stopAutoBackup = () => {
  if (backupTimer) {
    clearInterval(backupTimer);
    backupTimer = null;
  }
};

const getLastBackupTime = () => {
  return localStorage.getItem('ashop_last_backup');
};

export { runBackup, startAutoBackup, stopAutoBackup, getLastBackupTime };
